import { useEffect, useState } from 'react';

import { Text } from '../../../cdl/Text/Text';
import { TextButton } from '../../../common/buttons/TextButton';
import { translate } from '../../../common/helpers/translate.helper';
import { useKeyPorts } from '../../../common/hooks/useKeyPorts';
import { useRole } from '../../../common/hooks/useRole';
import { IconCircleCheck } from '../../../common/icons/cdl/CircleCheck';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { Box } from '../../../common/ui/Box';
import { useKeyPortCreate } from '../../../keyport/useKeyPortCreate';

export const AddKeyPort = ({ portId }) => {
    const [added, setAdded] = useState(false);

    const role = useRole();

    const { isKeyPort } = useKeyPorts();
    const { mutate: createKeyPort } = useKeyPortCreate({
        onSuccess: () => setAdded(true),
    });

    useEffect(() => {
        setAdded(false);
    }, [portId]);

    const onKeyPortButtonClick = (event) => {
        event.preventDefault();

        const keyPort = {
            customerGroupId: role.user.groupId,
            portId,
        };

        createKeyPort(keyPort);
    };

    if (added) {
        return (
            <Box display="flex" alignItems="center" color="positive.emphasis">
                <IconCircleCheck width={18} height={18} />
                <Text marginLeft={6} color="foreground.default" weight="semi">
                    {translate('compare.keyPort.successHint')}
                </Text>
            </Box>
        );
    }

    if (isKeyPort({ portId })) {
        return null;
    }

    return (
        <Box marginLeft="-5px">
            <TextButton onClick={onKeyPortButtonClick}>
                <IconPlus />
                {translate('compare.keyPort.addButton')}
            </TextButton>
        </Box>
    );
};
